import React from 'react';
import './StationCards.scss';

/**
 * Calcula el tiempo estimado de viaje basado en la distancia
 * Asume velocidad promedio de 30 km/h en zona urbana
 * @param {number} distanceKm - Distancia en kilómetros
 * @returns {string} - Tiempo formateado (ej: "5 min", "1 h 20 min")
 */
function calculateEstimatedTime(distanceKm) {
  const avgSpeedKmh = 30; // Velocidad promedio en ciudad
  const timeHours = distanceKm / avgSpeedKmh;
  const timeMinutes = Math.round(timeHours * 60);
  
  if (timeMinutes < 1) {
    return "< 1 min";
  } else if (timeMinutes < 60) {
    return `${timeMinutes} min`;
  } else {
    const hours = Math.floor(timeMinutes / 60);
    const mins = timeMinutes % 60;
    return mins > 0 ? `${hours} h ${mins} min` : `${hours} h`;
  }
}

/**
 * Formatea la distancia de manera legible
 * @param {number} distanceKm - Distancia en kilómetros
 * @returns {string} - Distancia formateada
 */
function formatDistance(distanceKm) {
  if (distanceKm < 1) {
    return `${Math.round(distanceKm * 1000)} m`;
  } else {
    return `${distanceKm.toFixed(1)} km`;
  }
}

function StationCards(props) {
  const sucursal = props.selectedStation;
  const showDistance = props.showDistance;
  return (
    <>
      {props.stations.map((location, i) => (
        <div key={location.id}
          className={"card card-station mt-2" + ( parseInt(location.id) === parseInt(sucursal?.id) ? ' selected':'')}
          onClick={ () => props.selectStation({ value: location.id }) }>
          <div className="card-body p-2">
            <p className="card-text">
              {location.address}
              {showDistance && location.distance !== undefined && (
                <span className="distance-info">
                  {i === 0 && <span className="nearest-badge">Más cercana</span>}
                  <span className="distance-km">
                    {formatDistance(location.distance)}
                  </span>
                </span>
              )}
            </p>
          </div>
        </div>
      ))}
    </>
  );
}

export default StationCards;
